import React from 'react';
import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import PageMeta from '../../components/pageMeta/PageMeta';
import BlogListComponent from '../../components/blogListComponent/blogListComponent';
import { BLOGS } from '../../common/Blogs';
import './blogList.css';

const BlogList = () => (
  <div className="insights-page">
    <PageMeta
      title="AI Agent Engineering Insights | TryOuts"
      description="Practical notes from TryOuts on production AI agents, retrieval systems, evaluation, automation, and agent architecture."
      path="/blog"
    />
    <Header />
    <main id="main-content" className="insights-main">
      <header className="insights-hero section--night">
        <div className="container">
          <p className="eyebrow">Insights / field notes</p>
          <h1>Notes from the space between demo and deployment.</h1>
          <p>Practical thinking on agent architecture, retrieval, evaluations, workflow design, and the choices that make AI systems useful in production.</p>
        </div>
      </header>

      <section className="section section--paper" aria-labelledby="latest-insights">
        <div className="container">
          <div className="insights-section-heading">
            <h2 id="latest-insights">Latest notes</h2>
            <span>{String(BLOGS.length).padStart(2, '0')} articles</span>
          </div>
          <div className="insights-grid">
            {BLOGS.map((blog, index) => (
              <BlogListComponent key={blog.name} blog={blog} index={index} />
            ))}
          </div>
        </div>
      </section>
    </main>
    <Footer />
  </div>
);

export default BlogList;
